import React from 'react';

import BookPageHeaderContent from './BookPageHeaderContent';
import BookPageHeaderEmpty from './BookPageHeaderEmpty';


const BookPageHeader = (props) => (
  props.book
    ? <BookPageHeaderContent {...props} />
    : <BookPageHeaderEmpty hideControls={props.hideControls} />
);

export default BookPageHeader;
